import { observer } from "mobx-react-lite";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import { CollectionViewPageListEmpty } from "@/pages/collections-view/components/CollectionsViewPageListEmpty";
import { MdsVirtualizedItemList } from "@/design-system/components/item-list";
import { useEffect } from "react";

export const CollectionsViewPageList = observer(() => {
  const page = useTabPageStore("collectionsViewPage");
  const collection = page.collectionObservable;

  page.listState.useListStateEffects();

  useEffect(() => {
    const addToRecents = async () => {
      if (!collection) return;
      await collection.addToRecents();
    };

    addToRecents();
  }, [collection]);

  if (!collection) return null;
  if (page.hasNoItems) {
    return <CollectionViewPageListEmpty />;
  }

  return (
    <>
      <MdsVirtualizedItemList
        rows={page.itemRows}
        listState={page.listState}
        scrollTop={page.scrollTop}
        endReached={page.filters.increaseLimit}
        setScrollTop={page.setScrollTop}
      />
      {page.listState.multiSelectUi}
    </>
  );
});
